/**
 * Map view for feeds.
 * Stale spaghetti.
 * TODO: Refactor it.
 */

const extend = require('xtend/mutable');
const on = require('emmy/on');
const delegate = require('emmy/delegate');
const emit = require('emmy/emit');
const q = require('queried');
const ajax = require('component-ajax');
const capfirst = require('capitalize');
const _ = require('./i18n');
const { Filter } = require('./feed/filter');
const { FacetController } = require('./feed/facet-filter');
const { createUrl } = require('./feed/core');
const feed = require('./feed');
const kudago = require('./kudago');
const {
  roubleToSign,
  getIcon,
  GOOGLE_API_KEY,
  round,
} = require('./utils');

// --------------------- Map view
const preview = q('.map-view-preview');
const mapViewLink = q('.map-view-link', preview);
const mapViewContainer = q('#map-view-container');
const mapView = q('#map-view');
const feedElement = q('.feed-container .feed');
const addresses = {}; // list of addresses (model) keyed by id
const markers = []; // list of markers on the map
const infoWindowContent = document.createElement('div');
const infoWindowTitle = document.createElement('div');
const infoWindowDescription = document.createElement('div');
let google;
let isMapActive = false;
let isMapLoaded = false;
let infoWindow; // balloon to show place info in
let map; // google map object
let geocoder;
let currentPosition;

// init info window
infoWindowContent.className = 'info-window-content';
infoWindowTitle.className = 'info-window-title';
infoWindowDescription.className = 'info-window-description';
infoWindowContent.appendChild(infoWindowTitle);
infoWindowContent.appendChild(infoWindowDescription);

// Main map launcher - show map button
on(preview, 'click', (e) => {
  e.preventDefault();
  if (!isMapActive) {
    showMap();
  } else {
    hideMap();
  }
});

// API: do all the routines to show the map
function showMap() {
  if (preview) {
    preview.classList.add('map-view-preview-active');
    preview.removeAttribute('hidden');
  }

  isMapActive = true;
  mapViewContainer.removeAttribute('hidden');
  mapViewContainer.classList.add('map-view-container-active');

  if (mapViewLink) {
    const text = _('Hide map');
    mapViewLink.innerHTML = `
      <i class="map-view-icon"></i>
      <span>${text}</span>
    `;
    mapViewLink.parentNode.classList.add('active');
  }

  if (map) {
    google.maps.event.trigger(map, 'resize');
  }
  loadMap(loadMorePlaces);
}

// API: do all the routine to hide the map
function hideMap() {
  isMapActive = false;
  mapViewContainer.setAttribute('hidden', true);
  mapViewContainer.classList.remove('map-view-container-active');
  const text = _('Show on map');
  mapViewLink.innerHTML = `
    <i class="map-view-icon"></i>
    <span>${text}</span>
  `;
  mapViewLink.parentNode.classList.remove('active');

  if (mapViewLink.closest('.map-view-preview')) {
    mapViewLink.closest('.map-view-preview').classList.remove('map-view-preview-active');
  }
}

// add markers of all the new addresses passed
function addPlaceMarkers(respPlaces) {
  markers.forEach((m) => m.setMap(null));

  respPlaces.forEach((place) => {
    if (!place.addresses) return;

    place.addresses.forEach((address) => {
      if (addresses[address.id] !== undefined) {
        addresses[address.id].marker.setMap(map);
        return;
      }

      if (!address.lat_lon) return;

      addresses[address.id] = address;

      const coords = address.lat_lon.split(/, ?/);

      const marker = new google.maps.Marker({
        map,
        address,
        position: new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1])),
        title: address.title || place.title,
        placeObj: place,
        id: address.id,
        icon: '/favicon.svg',
      });

      markers.push(marker);
      address.marker = marker;

      google.maps.event.addListener(marker, 'click', () => showMarkerInfo(marker));
    });
  });
}

function handleMarkerInfo() {
  if (!infoWindow.currentMarker) return;
  const marker = infoWindow.currentMarker;
  const isFavorite = marker.placeObj.is_favorite;
  const mapFav = q('.map-fav');
  const emptyHeart = q('.icon-heart-empty', mapFav);
  const solidHeart = q('.icon-heart', mapFav);
  const likesCount = q('.js-likes-number', mapFav);

  if (!kudago.user.isAuthenticated) {
    mapFav.setAttribute('data-disabled', 'true');
    emptyHeart.classList.add('post-fav-heart-off');
    solidHeart.classList.add('post-fav-heart-on');
    emptyHeart.classList.remove('post-fav-heart-on');
    solidHeart.classList.remove('post-fav-heart-off');
  } else if (isFavorite) {
    mapFav.setAttribute('data-active', 'true');
    mapFav.setAttribute('title', _('I don’t like it anymore'));

    emptyHeart.classList.add('post-fav-heart-off');
    solidHeart.classList.add('post-fav-heart-on');
    emptyHeart.classList.remove('post-fav-heart-on');
    solidHeart.classList.remove('post-fav-heart-off');
  } else {
    mapFav.removeAttribute('data-active');
    mapFav.setAttribute('title', _('I like it'));

    emptyHeart.classList.add('post-fav-heart-on');
    solidHeart.classList.add('post-fav-heart-off');
    emptyHeart.classList.remove('post-fav-heart-off');
    solidHeart.classList.remove('post-fav-heart-on');
  }

  const newLikesCount = +likesCount.innerHTML;

  likesCount.classList.remove('one-digits-size', 'two-digits-size', 'three-digits-size');

  if (newLikesCount > 99) {
    likesCount.classList.add('three-digits-size');
  } else if (newLikesCount < 100 && newLikesCount > 9) {
    likesCount.classList.add('two-digits-size');
  } else if (newLikesCount < 10) {
    likesCount.classList.add('one-digits-size');
  }

  likesCount.innerHTML = newLikesCount;
}

function showMarkerInfo(marker) {
  emit(preview, 'mapItemClick', { site_url: marker.placeObj.site_url });
  infoWindow.currentMarker = marker;
  infoWindow.setPosition(marker.getPosition());
  infoWindowTitle.innerHTML = `<h1 class="place-balloon-title"><a href="${marker.placeObj.site_url}" title="${_("To the place's page")}">${capfirst(marker.address.title || marker.placeObj.title)}</a></h1>`;
  infoWindowDescription.innerHTML = renderDescription(marker);
  infoWindow.open(map, marker);
}

// returns desc html
function renderDescription(marker) {
  const place = marker.placeObj;
  const { address } = marker;
  let cuisineStr = '';

  // cuisine
  const showCuisine = kudago.page == 'restaurants'
    && place.restaurantinfo
    && place.restaurantinfo.cuisine;

  if (showCuisine) {
    const showText = _('Show');

    place.restaurantinfo.cuisine.forEach((cuisine, index) => {
      const isLast = index == (place.restaurantinfo.cuisine.length - 1);
      const divider = isLast ? '' : ', ';

      cuisineStr += `
        <a
          class="place-balloon-detail-cuisine ajax-link"
          href="${kudago.originUrl}${cuisine.slug}/"
          title="${showText} ${cuisine.name}"
          data-mode="radio"
          data-key="cuisine"
          data-value="${cuisine.slug}"
        >${cuisine.name.toLowerCase()}</a>${divider}
      `;
    });
  }

  const { lat_lon } = address;
  const distance = getDistance({
    latitude: parseFloat(lat_lon.split(',')[0]),
    longitude: parseFloat(lat_lon.split(',')[1]),
  }, {
    latitude: currentPosition.lat(),
    longitude: currentPosition.lng(),
  });
  const distanceStr = (distance < 1) ? round(distance, 3) * 1000 + _('m') : round(distance, 2) + _('km');
  let time = round((distance * 11), 2);
  if (time > 600) {
    time = _('too much');
  } else if (time > 60) {
    time = _('more than an hour');
  } else {
    const min = _('min.');
    time = `≈${time}${min}`;
  }

  let imageMarkup = '';
  if (place.first_image) {
    const toPlace = _('To the place’s page');
    imageMarkup = document.body.classList.contains('body--noImages') ? '' : `
      <a class="place-balloon-preview" href="${place.site_url}" title="${toPlace}">
        <img class="place-balloon-preview-image" src="${place.first_image.small}"/>
      </a>
    `;
  }

  let descriptionMarkup;
  {
    const toPlace = _("To the place's page");
    const more = _('more');
    const showMore = `
      &nbsp;&nbsp;<a href="${place.site_url}" class="place-balloon-more-link" title="${toPlace}">
        <span>${more}</span>
        »
      </a>`;
    descriptionMarkup = cut(place.description || '', 120, showMore);
  }

  let restaurantInfo = '';
  if (place.restaurantinfo && place.restaurantinfo.average_bill) {
    const title = _('Average bill: %s', [place.restaurantinfo.average_bill]);
    const content = _('Average bill: %s', [`<strong>${roubleToSign(place.restaurantinfo.average_bill)}</strong>`]);
    restaurantInfo = `
      <span class="place-balloon-price nobr" title="${title}">
        ${content}
      </span>
    `;
  }

  let cuisineMarkup = '';
  if (cuisineStr) {
    const cuisine = _('Cuisine');
    cuisineMarkup = `
      <p class="place-balloon-detail">
        <i class="icon-cuisine"></i>${cuisine}: ${cuisineStr}
      </p>
    `;
  }

  let addressMarkup;
  {
    const walk = _('Walk');
    addressMarkup = `
      <p class="place-balloon-address">
        ${getIcon('location')}
        ${address.address},&nbsp;<span class="nobr">
        <i class="icon-walk" title="${walk} ${time}"></i>${distanceStr}
        </span>
      </p>
    `;
  }

  let timetableMarkup;
  if (place.working_hours.trim()) {
    const isInline = place.restaurantinfo
      && place.restaurantinfo.wifi
      && place.working_hours
      && place.working_hours.length < 30;

    timetableMarkup = `
      <p class="place-balloon-timetable${isInline ? ' inline' : ''}">
        ${getIcon('clock')}${place.working_hours}
      </p>
    `;
  }

  let wifiMarkup = '';
  if (place.restaurantinfo && place.restaurantinfo.wifi) {
    const isInline = place.working_hours && place.working_hours.trim().length < 30;
    const free = _('Free Wi-Fi');
    wifiMarkup = `
      <p class="place-balloon-wifi nobr${isInline ? ' inline' : ''}" title="${free}">
        <i class="icon-wifi"></i>Wi-Fi
      </p>`;
  }

  const likesMarkup = `
    <div class="map-fav js-likes" data-id="${place.id}" data-type="place">
      <div class="post-fav-inner-container">
        <div class="post-fav-hearts">
          ${getIcon('heart')}
          ${getIcon('heart-empty')}
        </div>
        <span class="js-likes-number post-fav-number">
          ${place.favorites_count}
        </span>
      </div>
    </div>
  `;

  return [
    '<p class="place-balloon-description">',
    imageMarkup,
    descriptionMarkup,
    restaurantInfo,
    '</p>',

    cuisineMarkup,
    addressMarkup,
    timetableMarkup,
    wifiMarkup,
    likesMarkup,
  ].join('');
}

// cuts text
// eslint-disable-next-line default-param-last
function cut(str, l = 120, cutStr) {
  return (str.length >= l ? `${str.slice(0, l).trim()}…${cutStr}` : str);
}

// first time maps loader
function loadMap(cb) {
  if (!isMapLoaded) {
    loadGoogleMapsScript();
    on(document, 'googleMapsReady', () => {
      isMapLoaded = true;
      initMap(cb);
    });
  } else if (cb) {
    cb();
  }
}

// ajax request to obtain data from the server
let isObtainingPlaces = false;
let loadMorePlacesTimeout;

function loadMorePlaces() {
  if (isObtainingPlaces) return;
  isObtainingPlaces = true;

  clearTimeout(loadMorePlacesTimeout);
  loadMorePlacesTimeout = setTimeout(_loadMorePlaces, 100);
}

let itemToShowMarkerId = null;

function _loadMorePlaces() {
  if (!feed) return;

  ajax({
    url: createUrl(feed.state, extend({
      response_type: 'json',
      fields: 'site_url,id,title,description,addresses,first_image,restaurantinfo,barinfo,price_per_hour,working_hours,favorites_count,is_favorite',
    }, getBounds())),
    success(resp) {
      isObtainingPlaces = false;
      addPlaceMarkers(resp.feed);
      mapView.classList.remove('preloading');
      // show description if map was opened on widget address click
      showItemDescriptionOnMap();
    },
    error() {
      isObtainingPlaces = false;
      mapView.classList.remove('preloading');
    },
  });
}

// retrieves current map bounds tostringed fot ajax request
function getBounds() {
  const bounds = map.getBounds();

  const boundsObj = {
    lat_left: bounds.getNorthEast().lat(),
    lat_right: bounds.getSouthWest().lat(),
    lon_right: bounds.getSouthWest().lng(),
    lon_left: bounds.getNorthEast().lng(),
  };

  return {
    bounds: [
      [boundsObj.lat_left, boundsObj.lon_left].join(','), [boundsObj.lat_right, boundsObj.lon_right].join(','),
    ].join(';'),
  };
}

// initializes google map
function initMap(cb) {
  const mapOptions = {
    zoom: 8,
    scrollwheel: false,
    center: new google.maps.LatLng(0, 0),
  };

  map = new google.maps.Map(mapView, mapOptions);

  // move to the location and zoom
  initLocation();

  // listen to the full load
  google.maps.event.addListenerOnce(map, 'idle', () => {
    if (cb) {
      cb();
    }

    // create balloon
    infoWindow = new google.maps.InfoWindow({
      maxWidth: 340,
    });
    infoWindow.setContent(infoWindowContent);
    infoWindow.addListener('closeclick', loadMorePlaces);
    infoWindow.addListener('domready', handleMarkerInfo);

    setTimeout(() => {
      mapView.classList.remove('preloading');
    }, 400);

    bindEvents();
  });
}

function updateMapViewPreloaderState(state) {
  const cls = 'preloading';

  if (state.page.ajaxInProgress) {
    mapView.classList.add(cls);
  } else {
    mapView.classList.remove(cls);
  }
}

// register map events
function bindEvents() {
  if (feed) {
    feed.on('update', (state) => updateMapViewPreloaderState(state));

    feed.on('sync', (state) => {
      loadMorePlaces();
      updateMapViewPreloaderState(state);
    });

    new FacetController(feed, new Filter(feed, mapView));
  }

  // add UI events
  google.maps.event.addListener(map, 'bounds_changed', loadMorePlaces);
  google.maps.event.addListener(map, 'tilt_changed', loadMorePlaces);
}

// Ask location firstly and if user denied - locate the city by google geo
function initLocation() {
  currentPosition = kudago.locationCoords
    ? new google.maps.LatLng(kudago.locationCoords.lat, kudago.locationCoords.lng)
    : map.getCenter();

  // detect city center, then ask user to allow detecting geolocation by browser
  geocodeLocation((bounds) => {
    if ('geolocation' in navigator) {
      // if browser supports geolocation - ask user about location
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { coords } = position;
          currentPosition = new google.maps.LatLng(coords.latitude, coords.longitude);
          // if user agreed on showing his location - detect whether he is within current map view
          if (bounds.contains(currentPosition)) {
            // if current location is comprised by map - show it
            const marker = new google.maps.Marker({
              map,
              position: currentPosition,
              title: _('You are here'),
              icon: `${kudago.staticBaseUrl}img/location.png`,
            });
            // if distance is too big, ignore positioning
            map.setCenter(currentPosition);
            map.setZoom(14);
            marker.setZIndex(1);

            google.maps.event.addListener(marker, 'click', () => {
              infoWindow.setPosition(marker.getPosition());
              infoWindowTitle.innerHTML = `<h1 class="current-location-title">${_('You are here')}</h1>`;
              infoWindowDescription.innerHTML = '';
              infoWindow.open(map, marker);
            });
          } else {
            // if current location is out of map - show the center of the city
          }
        },
        () => {
          // if user disagreed on showing his location - keep map centered on the city
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        },
      );
    } else {
      // If browser doesn't support geolocation - show the center of the city
    }
  });
}

// helper - detects location of the city
function geocodeLocation(cb) {
  // geocode default location
  geocoder = new google.maps.Geocoder();
  geocoder.geocode({
    address: kudago.locations[kudago.location].N,
  }, (results) => {
    map.setCenter(results[0].geometry.location);
    map.setZoom(map.getZoom() + 3); // zoom in a bit
    cb(results[0].geometry.bounds);
  });
}

function showItemDescriptionOnMap() {
  const id = itemToShowMarkerId;
  itemToShowMarkerId = null;

  // if this place marker is shown on map
  if (id && addresses[id]) {
    const { marker } = addresses[id];
    google.maps.event.trigger(marker, 'click', {});
  }
}

// Link places addresses click
delegate(feedElement, 'click', '.post-detail-address-link', (e) => {
  const id = e.delegateTarget.parentNode.getAttribute('data-place-id');

  if (id) {
    itemToShowMarkerId = id;

    if (isMapActive) {
      showItemDescriptionOnMap();
    } else {
      showMap();
    }
  }
});

// Converts numeric degrees to radians
function toRad(n) {
  return n * Math.PI / 180;
}

// heartt and end are objects with latitude and longitude
// return is distance in kilometers.
function getDistance(heartt, end) {
  const earthRadius = 6371; // km
  let lat1 = parseFloat(heartt.latitude);
  let lat2 = parseFloat(end.latitude);
  const lon1 = parseFloat(heartt.longitude);
  const lon2 = parseFloat(end.longitude);

  const dLat = toRad((lat2 - lat1));
  const dLon = toRad((lon2 - lon1));
  lat1 = toRad(lat1);
  lat2 = toRad(lat2);

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
    + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return earthRadius * c;
}

// ------------------------Google maps loading stuff
// Has to be in the global scope

function loadGoogleMapsScript() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&sensor=false&callback=gmready`;
  script.async = true;
  document.body.appendChild(script);
}

// TODO: remove this global variable
window.gmready = function () {
  google = window.google;
  emit(document, 'googleMapsReady');
};
